import { classed } from "@frend-digital/ui";
import styles from "./Tags.module.css";

export type TagsProps = {};

export const Tags = classed.div(styles.root);

export const Tag = classed.div(styles.tag, {
	variants: {
		outlined: {
			true: styles.outlined,
		},
		filled: {
			true: styles.filled,
		},
	},
});
